//MachineContext.js
import React, { createContext, useState, useEffect } from 'react';

export const MachineContext = createContext();

export const MachineProvider = ({ children }) => {
  const [machineCode, setMachineCode] = useState(() => {
    // Retrieve machine code from local storage on component mount
    return localStorage.getItem('machineCode') || '';
  });

  useEffect(() => {
    // Store machine code in local storage whenever it changes
    localStorage.setItem('machineCode', machineCode);
  }, [machineCode]);

  return (
    <MachineContext.Provider value={{ machineCode, setMachineCode }}>
      {children}
    </MachineContext.Provider>
  );
};

export const useMachine = () => {
  const context = React.useContext(MachineContext);
  if (!context) {
    throw new Error('useMachine must be used within a MachineProvider');
  }
  return context;
};
